
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface OrderStatusBadgeProps {
  status: string;
}

const OrderStatusBadge = ({ status }: OrderStatusBadgeProps) => {
  // Translate status to Albanian
  const translateStatus = (status: string): string => {
    const translations: { [key: string]: string } = {
      'pending': 'Në pritje',
      'processing': 'Duke u procesuar',
      'shipped': 'Dërguar',
      'delivered': 'Dorëzuar',
      'completed': 'Përfunduar',
      'cancelled': 'Anuluar'
    };
    
    return translations[status] || status;
  };
  
  // Render based on status
  switch (status) {
    case 'pending':
      return <Badge variant="outline" className="bg-yellow-100 text-yellow-800 border-yellow-300">Në pritje</Badge>;
    case 'processing':
      return <Badge variant="outline" className="bg-blue-100 text-blue-800 border-blue-300">Duke u procesuar</Badge>;
    case 'shipped':
      return <Badge variant="outline" className="bg-purple-100 text-purple-800 border-purple-300">Dërguar</Badge>;
    case 'delivered':
      return <Badge variant="outline" className="bg-orange-100 text-orange-800 border-orange-300">Dorëzuar</Badge>;
    case 'completed':
      return <Badge variant="outline" className="bg-green-100 text-green-800 border-green-300">Përfunduar</Badge>;
    case 'cancelled':
      return <Badge variant="outline" className="bg-red-100 text-red-800 border-red-300">Anuluar</Badge>;
    default:
      return <Badge variant="outline">{translateStatus(status)}</Badge>;
  }
};

export default OrderStatusBadge;
